import React from 'react';
import { Copy, Linkedin } from 'lucide-react';
import { toast } from 'sonner';

const ShareMenu = ({ text, url, onClose }) => {
  const handleNativeShare = async () => {
    try {
      await navigator.share({ title: text, text: text, url: url });
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Share failed:', err);
      }
    }
    onClose();
  };

  const shareTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`, '_blank');
    onClose();
  };

  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(text + '\n' + url)}`, '_blank');
    onClose();
  };

  const shareLinkedIn = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
    onClose();
  };

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    toast.success('Link kopiert!');
    onClose();
  };

  // Mobile: use native share if available
  const canNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

  if (canNativeShare) {
    // On mobile: show native share + copy fallback
    return (
      <div className="absolute bottom-7 right-0 bg-white border rounded-xl shadow-xl p-2 z-20 flex gap-2 animate-in fade-in zoom-in-95 duration-150 dark:bg-slate-900/80">
        <button
          onClick={handleNativeShare}
          className="text-[10px] px-3 py-1.5 bg-blue-900 text-white rounded-lg font-medium hover:bg-blue-800 transition-colors"
          data-testid="share-native"
        >
          Teilen
        </button>
        <button
          onClick={copyLink}
          className="text-[10px] px-2.5 py-1.5 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 dark:bg-slate-800"
          data-testid="share-copy"
        >
          <Copy size={10} /> Link
        </button>
      </div>
    );
  }

  // Desktop: show platform buttons
  return (
    <div className="absolute bottom-7 right-0 bg-white border rounded-xl shadow-xl p-2 z-20 flex gap-1.5 animate-in fade-in zoom-in-95 duration-150 dark:bg-slate-900/80">
      <button
        onClick={shareTwitter}
        className="text-[10px] px-2.5 py-1.5 bg-blue-900 text-white rounded-lg font-medium hover:bg-blue-800 transition-colors"
        data-testid="share-twitter"
      >
        X
      </button>
      <button
        onClick={shareWhatsApp}
        className="text-[10px] px-2.5 py-1.5 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600 transition-colors"
        data-testid="share-whatsapp"
      >
        WA
      </button>
      <button
        onClick={shareLinkedIn}
        className="text-[10px] px-2.5 py-1.5 bg-blue-700 text-white rounded-lg font-medium hover:bg-blue-800 transition-colors flex items-center gap-1"
        data-testid="share-linkedin"
      >
        <Linkedin size={10} /> in
      </button>
      <button
        onClick={copyLink}
        className="text-[10px] px-2.5 py-1.5 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 dark:bg-slate-800"
        data-testid="share-copy"
      >
        <Copy size={10} />
      </button>
    </div>
  );
};

export default ShareMenu;
